<template>
    <div class="magazine-taxonomy-page">
        <template v-if="taxonomyPage">
            <MagazineHeader
                v-if="taxonomyPage.taxonomySettings.header_image_url"
                :image="taxonomyPage.taxonomySettings.header_image_url"
                :title="taxonomyPage.taxonomySettings.header_title"
                :alt="taxonomyPage.taxonomySettings.header_image_alt_text"
            />
            <div class="mag-wrap mag-wrap--narrow">
                <MagazineBreadcrumbs :current-name="taxonomyPage.name" class="magazine__breadcrumbs" />
            </div>
            <section v-if="showPills" class="mag-section">
                <div class="mag-wrap mag-wrap--narrow">
                    <PillList
                        :heading="taxonomyPage.subNavigationData && taxonomyPage.subNavigationData.heading"
                        :pills="taxonomyPage.subNavigationData && taxonomyPage.subNavigationData.links"
                    />
                </div>
            </section>
            <slot name="wp-content" />
            <section class="mag-section">
                <div class="mag-wrap mag-wrap--narrow">
                    <PostList
                        ref="postList"
                        :taxonomy-term="taxonomyTerm"
                        :ids="taxonomyPage.id"
                        :settings="taxonomyPage.taxonomySettings"
                        :exclude-ids="taxonomyPage.excludePostIds"
                        :show-heading="postListHeading !== ''"
                        @page-change="scrollToPostList"
                    >
                        {{ postListHeading }}
                    </PostList>
                </div>
            </section>
            <section v-if="taxonomyPage.description" class="mag-section">
                <div class="mag-wrap mag-wrap--narrow">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <div v-html="taxonomyPage.description" />
                </div>
            </section>
        </template>
        <LoadingIndicator v-else class="magazine-taxonomy-page__loading" />
    </div>
</template>

<script>
import LoadingIndicator from '~/components/LoadingIndicator.vue';
import MagazineHeader from '~/components/magazine/MagazineHeader.vue';
import MagazineBreadcrumbs from '~/components/magazine/MagazineBreadcrumbs.vue';
import PillList from '~/components/PillList.vue';
import PostList from '~/components/magazine/PostList.vue';

export default {
    components: {
        LoadingIndicator,
        MagazineHeader,
        MagazineBreadcrumbs,
        PillList,
        PostList,
    },
    props: {
        taxonomyTerm: {
            type: String,
            required: true,
        },
        taxonomyPage: {
            type: Object,
            default: null,
        },
        showPills: {
            type: Boolean,
            default: true,
        },
        postListHeading: {
            type: String,
            default: '',
        },
    },
    methods: {
        scrollToPostList() {
            if (!this.$refs.postList || !this.$refs.postList.$el) {
                return;
            }

            setTimeout(() => {
                const elementTop = this.$refs.postList.$el.getBoundingClientRect().top;
                const offset = elementTop - 40;
                window.scrollBy({
                    top: offset,
                    behavior: 'smooth',
                });
            }, 0); // Wait for the post list to render
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.magazine-taxonomy-page {
    &__breadcrumbs {
        padding-top: $sm-magazine-spacing;
    }

    &__loading {
        height: calc(100dvh - $main-header-md-height);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    p {
        margin-bottom: 0; // Issues with the description content at the bottom
    }

    .pill-list {
        padding-bottom: $lg-magazine-spacing;
        border-bottom: 1px solid $gray;
    }
}
</style>
